import Vue from 'vue';
import Router from 'vue-router';

import ObrigadoAlmaGemea from '../components/ObrigadoAlmaGemea.vue';
import ObrigadoAlmaGemeaCakto from '../components/ObrigadoAlmaGemeaCakto';
import ObrigadoTarot from '../components/ObrigadoTarot.vue';
import ObrigadoSegundaAlmaGemea from '../components/ObrigadoSegundaAlmaGemea.vue';
import ObrigadoVidasPassadas from '../components/ObrigadoVidasPassadas.vue';
import ObrigadoTarotYesNo from '../components/ObrigadoTarotYesNo.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/obrigado-almagemea',
      name: 'ObrigadoAlmaGemea',
      component: ObrigadoAlmaGemea,
      props: false
    },
    {
      path: '/obrigado-almagemeac',
      name: 'ObrigadoAlmaGemeaCakto',
      component: ObrigadoAlmaGemeaCakto,
      props: false
    },
    {
      path: '/obrigado-segundaalmagemea',
      name: 'ObrigadoSegundaAlmaGemea',
      component: ObrigadoSegundaAlmaGemea,
      props: false
    },
    {
      path: '/obrigado-tarot',
      name: 'ObrigadoTarot',
      component: ObrigadoTarot,
      props: false
    },
    {
      path: '/obrigado-vidas-passadas',
      name: 'ObrigadoVidasPassadas',
      component: ObrigadoVidasPassadas,
      props: false
    },{
      path: '/tarot-rec-yes-no',
      name: 'ObrigadoTarotYesNo',
      component: ObrigadoTarotYesNo,
      props: false
    },
  ],
});
